import React from "react";
import { useTranslation } from "react-i18next";
import { ILoginInputConfig, ITextBoxInputConfig } from "../RelationAccesses/IModels";
import { LabelFormRow } from "./FormsControls";
import { createStyles, makeStyles } from "@material-ui/styles";
import clsx from "clsx";
import lang from './RelationsLang';
import { TextField, Tooltip, Typography } from "@material-ui/core";
import { LoginGeneratorField } from "../LoginGenerator/LoginGeneratorField";

const useStyles = makeStyles((theme) =>
	createStyles({
		label: {
			color: '#888',
			display: 'block',
		},
		textInput: {
			'& input[type="text"]': {
				padding: '9px',
			}
		},
		formRow: {
			marginTop: '14px'
		}
	}),
);

interface IProps {
	name: string,
	errorText: string,
	config: ILoginInputConfig;

	value: string,
	onChange: (v: string) => void,
	onChangedReferenceNumber: (args: string) => void,
	onChangedLocation: (args: string) => void,

	applicationId: number;
	employeeId: number | null;
}

export function LoginFieldFormRow(props: IProps) {
	const classes = useStyles();

	return <div className={classes.formRow} >
		{props.errorText && <p className="text-danger">{props.errorText}</p>}
		{!props.config.hidden && <form autoComplete="off" >
			<div className="text-field">
				<LabelFormRow
					{...props}
				/>
				<div>
					{props.config.showLoginGenerator && <LoginGeneratorField
						value={props.value}
						onChange={(e) => props.onChange(e)}
						applicationId={props.applicationId}
						employeeId={props.employeeId}
						onChangedLocation={props.onChangedLocation}
						onChangedReferenceNumber={props.onChangedReferenceNumber}
						loginGeneratorConfig={props.config.loginGeneratorConfig}
					/>}
					{!props.config.showLoginGenerator && <TextField
						InputProps={{
							className: classes.textInput,
						}}
						type="text"
						value={props.value}
						onChange={(e) => props.onChange(e.target.value)}
						error={!!props.errorText}
						className={clsx("text-input")}
						placeholder={lang.getDefaultByPrefix(props.config, "placeholder")}

						variant="outlined"
						fullWidth
					/>}
				</div>
			</div>
		</form>}
	</div>
}